const state = () => ({
  show_copyrightnotice_everywhere: false
})

const getters = {
  showCopyrightnotice: state => {
    return state.show_copyrightnotice_everywhere
  }
}

const mutations = {
  SET_SHOW_COPRIGHTNOTICE(state, bool) {
    state.show_copyrightnotice_everywhere = !!bool
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
